const _temp0 = require("./commingsoon.webp");
const _temp1 = require("./img1.webp");
const _temp2 = require("./stock1.webp");
module.exports = {
  "commingsoon": _temp0,
  "img1": _temp1,
  "stock1": _temp2
}